// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"6454":"Widgets","7051":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] || chunkId) + "." + {"4046":"4d6af177","4851":"8a480b87","6454":"ac119948","6996":"d61843bd","7051":"ac119948","7597":"6d877d0d"}[chunkId] + ".chunk.css";
};